/*
    Takes a text input, splits it by line breaks, removes empty lines, wraps each line in <li> tags,
    and returns a string of all lines joined together.
*/
export const formatTextBlobToList = text => {
    return text
        .split(/\r?\n/) // split by line breaks
        .filter(line => line.trim() !== '') // Remove empty lines
        .map((line, index) => <li key={index}>{line.replace(/^-/, '')}</li>); // Remove "-" at the beginning of each line
};
